// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/AssetsPage/styles.scss
// module id = 1098
// module chunks = 0